import {useState } from 'react';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import './PlatformFaq.css';
import { Link } from 'react-router-dom';


const PlatformFaq = () => {
  // Expand all panels by default
  const [expanded, setExpanded] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  // Data for each accordion
  const accordionData = [
    {
      title: "How does Rentid’s pricing work?",
      content: ["Rentid offers two flexible pricing models: PayGo, where you only pay when your vehicle is rented, and Subscription, which provides unlimited use for a flat monthly fee."]
    },
    {
      title: "Can I switch between PayGo and Subscription?",
      content: ["Yes! You can upgrade, downgrade, or switch between plans anytime at the vehicle level, giving you full flexibility to adjust based on your business needs."]
    },
    {
      title: "Is there a free plan?",
      content: ["Yes! You can set up your account, list vehicles, and access essential features at no cost. You’ll only be charged when your vehicle is rented or if you opt for a Subscription."]
    },
    {
      title: "Do I have to commit to a long-term contract?",
      content: ["No. Rentid’s plans are month-to-month with no long-term commitments, allowing you to scale or adjust as needed."]
    },
    {
      title: "How does the PayGo plan work?",
      content: ["With PayGo, you only pay when your vehicle gets rented—ideal for hosts with seasonal demand or lower rental frequency."]
    },
    {
      title: "What’s included in the PayGo plan?",
      content: ["You get full access to Rentid’s core rental management features, including booking management, rental agreements, fleet tracking, and essential integrations."]
    },
    {
      title: "How much does PayGo cost?",
      content: ["PayGo is priced per rental day, and you’ll be charged only when a booking occurs. The rate is $7 per rental day."]
    },
    {
      title: "Can I use premium features on PayGo?",
      content: ["Yes, but some advanced features, such as telemetry tracking, insurance add-ons, and certain automation tools, may require an additional fee."]
    },
    {
      title: "What happens if I don’t rent out my vehicle on PayGo?",
      content: ["You won’t be charged unless your vehicle is rented, making PayGo a risk-free option for vehicles with lower or unpredictable utilization."]
    },
    {
      title: "How does the Subscription plan work?",
      content: ["Subscription gives you unlimited access to Rentid’s features for a flat monthly fee of $70 per vehicle, regardless of how often your vehicle is rented."]
    },
    {
      title: "What’s included in the Subscription plan?",
      content: ["Subscription includes all premium features, such as unlimited bookings, revenue opportunities, and access to nationwide roadside assistance."]
    },
    {
      title: "Can I cancel my Subscription anytime?",
      content: ["Yes! You can cancel or switch plans anytime without penalties."]
    },
    {
      title: "How does billing work for different vehicles?",
      content: ["Billing is managed at the vehicle level, meaning you can assign different plans to different vehicles based on their utilization."]
    },
    {
      title: "Are there any additional fees?",
      content: ["There are no hidden fees! However, certain add-ons like advanced analytics, premium insurance, or API access may have extra costs."]
    },
    {
      title: "How do I change my billing preferences?",
      content: ["You can update your plan directly from your dashboard—adjust pricing, enable add-ons, or modify vehicle-level settings anytime."]
    },
    {
      title: "How do I contact support if I have billing questions?",
      content: ["Our team is here to help! Reach out via [Talk to Sales] for pricing inquiries or visit our support portal for billing-related assistance."]
    },
    {
      title: "Can I use Rentid for multiple locations under one account?",
      content: ["Yes! Rentid allows you to manage multiple locations under one account, with no additional fees."]
    },
    {
      title: "Does Rentid offer pricing for large fleets?",
      content: ["Yes! For fleets over 1,000 vehicles, we offer custom pricing, API integrations, and dedicated support to fit your business needs. Contact Sales to explore solutions tailored to high-volume operators."]
    },
    {
      title: "Can I mix and match PayGo and Subscription within my fleet?",
      content: ["Absolutely! Rentid’s flexible billing allows you to assign different plans to different vehicles, giving you total control over costs."]
    },
    {
      title: "What’s the best plan for my business?",
      content: ["If you rent vehicles frequently, Subscription offers predictable pricing and full feature access. If your rentals are occasional or seasonal, PayGo ensures you only pay when you earn."]
    },
  ];

 ;


  const handleExpandClick = () => {
    if (isExpanded) {
      // Collapse all and show only the first two
      setExpanded([]);
    } else {
      // Expand all
     // setExpanded(accordionData.map((_, index) => `panel${index}`));
    }
    setIsExpanded(!isExpanded);
  };
  
  

 

  // Toggle accordion panels without collapsing others
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded ? [...prevExpanded, panel] : prevExpanded.filter(p => p !== panel)
    );
  };

  return (
    <section className='supportFaqMain platformFaqMain'>
      <div className='container'>
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="platformFaqHead">
                    <small>Enterprise</small>
                    <h2>Frequently questions</h2>
                </div>
            </div>
        </div>

        <div className="row justify-content-center align-items-center">       
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="supportFaqRight">
                <div className="supportFaqIcon">
                    <div className="row align-items-center">
                    <div className="col-md-4 col-4 faqIcon">
                      <img src="/img/faq.svg" alt="FAQ" className="img-fluid" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="d-flex align-items-center justify-content-end m-0"> 
                      <Link onClick={handleExpandClick} className='expandimg expandBtn'>
                      <img
                        src={isExpanded ? "/img/collapse.svg" : "/img/expand-arrow.svg"}
                        alt="Expand arrow"
                        width="24"
                      />
                      {isExpanded ? 'Collapse' : 'Expand'}
                    </Link>
                      </p>
                    </div>
                    </div>
                </div>
                <div className="headSupportFaq">
                  <h2>FAQ</h2>
                </div>
                <div className="supportFaqRight_Inn">
                  {accordionData.map((accordion, index) => (
                    (isExpanded || index < 2) && (
                      <Box key={index} className="boxAccordian">
                        <Accordion className="headingAccordian"
                          expanded={expanded.includes(`panel${index}`)}
                          onChange={handleAccordionChange(`panel${index}`)}
                        >
                        <AccordionSummary
                      expandIcon={
                        expanded.includes(`panel${index}`) ? (
                          <Typography variant="h6">−</Typography>
                        ) : (
                          <Typography variant="h6">+</Typography>
                        )
                      }
                      aria-controls={`panel${index}-content`}
                    >
                      <Typography>{accordion.title}</Typography>
                    </AccordionSummary>

                        </Accordion>
                        {expanded.includes(`panel${index}`) && (
                          <Box className="summaryAccordian">
                            <Typography>{accordion.content}</Typography>
                          </Box>
                        )}
                      </Box>
                    )
                  ))}

                </div>

                <div className="load-more">
                    <a onClick={handleExpandClick}>  {isExpanded ? 'View Less' : 'View More'}  <img className='img-fluid'   src={isExpanded ? "img/load-more-less.png" : "/img/faq-elements.png"}  alt="View More"/></a>                    
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformFaq;
